import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { handleWhatsAppClick } from './HandleWhatsappClick'; // Adjust path as needed

const DESKTOP_BREAKPOINT = 1000;
const MOBILE_OFFSET = '20px';
const DESKTOP_RIGHT_OFFSET = '4rem';
const DESKTOP_BOTTOM_OFFSET = '3rem';
const DESKTOP_CLEAR_STACK_OFFSET = 'calc(3rem + 52px)';

const WhatsAppButton = () => {
  const location = useLocation();
  const isCatalogPage = location.pathname.startsWith('/catalog');
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth > DESKTOP_BREAKPOINT : false
  );
  const [shouldLiftForCatalogClear, setShouldLiftForCatalogClear] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return undefined;
    }

    const updateButtonState = () => {
      const desktopViewport = window.innerWidth > DESKTOP_BREAKPOINT;
      setIsDesktop(desktopViewport);

      const hasDesktopCatalogClearButton =
        isCatalogPage &&
        desktopViewport &&
        Boolean(document.querySelector('.Text-Clear-Button.is-visible .floating-clear-btn'));

      setShouldLiftForCatalogClear(hasDesktopCatalogClearButton);
    };

    updateButtonState();

    const observer = new MutationObserver(updateButtonState);
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    window.addEventListener('resize', updateButtonState);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateButtonState);
    };
  }, [isCatalogPage]);

  // Handle WhatsApp link click
  const handleClick = (e) => {
    if (isCatalogPage) {
      e.preventDefault();
      e.stopPropagation();
      handleWhatsAppClick();
      return false;
    }
  };

  // Always use a very low z-index when on catalog page
  const baseZIndex = isCatalogPage ? 5 : 100;
  const bottomOffset = isDesktop
    ? shouldLiftForCatalogClear
      ? DESKTOP_CLEAR_STACK_OFFSET
      : DESKTOP_BOTTOM_OFFSET
    : MOBILE_OFFSET;
  const rightOffset = isDesktop ? DESKTOP_RIGHT_OFFSET : MOBILE_OFFSET;

  return (
    <a
      href="https://wa.me/+61449992363?text="
      className={`whatsapp-float-button ${isCatalogPage ? 'catalog-page' : ''} ${shouldLiftForCatalogClear ? 'desktop-lifted' : ''}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      style={{
        zIndex: baseZIndex,
        position: 'fixed',
        bottom: bottomOffset,
        right: rightOffset,
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
        <path
          fill="black"
          d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"
        />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
